/**
 * Remote Experiments Configuration - A/B Testing & Controlled Experiments
 *
 * Use this object to define all experiments used in the application.
 * Each experiment must follow the `RemoteExperimentType` structure.
 *
 * Example:
 * ```
 * PINK_HEADER_TEST: {
 *   key: 'exp_kjca123_pink_header',
 *   trackingKey: 'kjca123',
 *   defaultValue: {
 *     int: ExperimentValues.INTERNAL_ON,
 *     prod: ExperimentValues.EVERYONE_ELSE,
 *   },
 * }
 * ```
 * **Key Guidelines:**
 * - `key`: Must start with the prefix `exp_` followed by a unique identifier. Use a descriptive name indicating the experiment's purpose.
 * - `trackingKey`: A key prefixed by `kjca` used for tracking. Should align with story JIRA ticket.
 * - `defaultValue`: An object defining the default/fallback values for both integration (`int`) and production (`prod`) environments.
 */
import { type RemoteExperimentType, ExperimentValues } from '@/lib/firebase/types'

export const RemoteExperiments = {
  SMALLER_MASTHEAD_TEST: {
    key: 'exp_kjca4473_smaller_masthead',
    defaultValue: { int: ExperimentValues.GROUP_A, prod: ExperimentValues.EVERYONE_ELSE },
    trackingKey: 'kjca4473',
  },
} as const satisfies RemoteExperimentType
